import theme from '@styles/theme';
export default {
  section: {
    background: theme.rawColors.lightGrey300,
    padding: ['40px 12px', '40px 12px', '64px 0', '88px 0'],
    height: 'auto',
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  }
};